import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle,DropdownItem } from 'reactstrap';
import {Button, ButtonGroup} from 'reactstrap';

import LoadingProgress from '../../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {fetchEquipmentDataIfNeeded} from '../../../redux/actions/EquipmentActions'
import * as TextManager from "../../../modules/languages/TextManager";


class MultiSelectionFilter extends ReactQueryParams {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);

        this.state = {
            dropdownOpen: false,
            items:[],
            loading:false,
            chosenItems: [],
            searchValue: ''
        };
    }

    componentDidMount() {
        this.setState({items: this.props.items,
            search: this.props.search,
            chosenItems: this.queryParams[this.props.queryParam] ? this.queryParams[this.props.queryParam] : []
        });
    }

    toggle(e) {

        /*if (!this.state.dropdownOpen){
            this.setState({loading:true});

            http.postToServer('affiliates_assets/' + this.props.endpoint,
                {},
                (response) =>
                {this.setState({items:response.data,loading:false})},
                () => console.log('error getting Products filter'));

        }*/
        this.setState({
            dropdownOpen: !this.state.dropdownOpen, chosenItems: this.queryParams[this.props.queryParam] ? this.queryParams[this.props.queryParam] : undefined
        });
    }

    chooseItem(id){
        //console.log(this.state.chosenItems, id);

        let group = undefined;

        if(this.props.storeGroup && this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.storeGroup) {
            let storeGroups = this.props.utilsData.data.storeGroup;

            if(storeGroups) {
                group = storeGroups.find(a => a.label.split(',').map(x => +x).includes(id));
            }
        }

        if(id === 0 && this.state.chosenItems !== undefined){
            this.setState({
                chosenItems: undefined
            })
        }
        else if(id === 0 && this.state.chosenItems === undefined){
            this.setState({
                chosenItems: this.state.items.map(a => a.value)
            })
        }
        else if(this.state.chosenItems && this.state.chosenItems.includes(id)){

            if(group) {
                let tmpArr = group.label.split(',').map(x=>+x);
                this.setState({
                    chosenItems: this.state.chosenItems.filter(i => !tmpArr.includes(i))
                })
            }
            else {
                this.setState({
                    chosenItems: this.state.chosenItems.filter(i => i !== id)
                })
            }
        }
        else{

            if(group) {
                let tmpData = [
                    ...(this.state.chosenItems ? this.state.chosenItems.filter(i => i !== id) : []),
                    id].concat(group.label.split(',').map(x=>+x).filter(i => i !== id));

                this.setState({
                    chosenItems: tmpData
                })
            }
            else {
                this.setState({
                    chosenItems: [
                        ...(this.state.chosenItems ? this.state.chosenItems.filter(i => i !== id) : []),
                        id
                    ]
                })
            }
        }

    }

    chooseItemApply(){
        //console.log(this.state.chosenItems);
        //console.log(this.props.storeGroup);

        var queryParam = {};
        queryParam[this.props.queryParam] = this.state.chosenItems;
        this.setQueryParams(queryParam);

        this.props.dispatch(fetchEquipmentDataIfNeeded(this.queryParams));
    }

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        }
        else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                }
                else if(typeof mr === 'object'){
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {

        //console.log(this.queryParams[this.props.queryParam]);

        let name = '';
        let item = this.queryParams[this.props.queryParam];
        if (!item){
            name = this.props.name;
        }
        else {
            let obj = this.state.items.find(e => e.value === parseInt(item[0]));
            if(obj !== undefined) {
                name = obj.label + (item.length > 1 ?  (" +" + (item.length - 1)) : "");
            }
            else{
                if(item && Array.isArray(item) && item.length === 0){
                    name = this.props.name;
                }
            }
        }

        let data = this.state.items;

        if(this.state.searchValue !== '') {
            data = this.state.items.filter(this.filterDataBySearch)
        }

        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle
                    className="icon icon--right btn btn-outline-primary btn-sm"
                    tag="span"
                    onClick={this.toggle}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen}
                >
                    <p>
                        {name}
                        <svg width="24" height="24" viewBox="0 0 24 24" className="mdi-icon">
                            <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                        </svg>
                    </p>

                </DropdownToggle>
                <DropdownMenu className='dropdown__menu'>
                    {this.state.loading &&
                    <DropdownItem>
                        <LoadingProgress></LoadingProgress>
                    </DropdownItem>
                    }

                    <div style={{display: 'flex', flexDirection: 'row-reverse', maxHeight: "500px", overflow: 'auto'}}>
                        <div style={{width: '100%'}}>
                            {this.state.search &&
                                <input dir="rtl" style={{border: 'groove', width: '160px'}}
                                       placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                       value={this.state.searchValue}
                                       onChange={(e) => this.changeSearch(e)}/>
                            }
                            {!this.state.loading &&
                            data.map((currItem, index) =>
                                <DropdownItem active={this.state.chosenItems ? this.state.chosenItems.includes(currItem.value) : false}
                                              key={index}
                                              toggle={false}
                                              onClick={(e)=>{
                                                    this.chooseItem(currItem.value)
                                                }}>
                                    {currItem.label}
                                </DropdownItem>
                            )
                            }
                        </div>
                    </div>

                    <DropdownItem header style={{display: 'flex', justifyContent:'space-between'}}>
                        <ButtonGroup className='btn-group--icons'
                                     style={{marginTop: "10px", float: "right"}}>
                            <Button outline color='primary'
                                    onClick={() => this.chooseItemApply()}>{TextManager.getCurrentTextResource().Utils.apply}</Button>
                        </ButtonGroup>
                        <ButtonGroup className='btn-group--icons'
                                     style={{marginTop: "10px", float: "right"}}>
                            {!(this.state.chosenItems === undefined) && <Button outline color='primary'
                                    onClick={() => this.chooseItem(0)}>{TextManager.getCurrentTextResource().Utils.cleanSelection}</Button>}
                            {this.state.chosenItems === undefined && <Button outline color='primary'
                                                                                onClick={() => this.chooseItem(0)}>{TextManager.getCurrentTextResource().Utils.selectAll}</Button>}
                        </ButtonGroup>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        utilsData:state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(MultiSelectionFilter))
